import Tipe71 from "./tipe 7a (1).webp";
import Tipe72 from "./tipe 7a (2).webp";
import Tipe73 from "./tipe 7b (1).webp";
import Tipe74 from "./tipe 7b (2).webp";

const tipe7 = [Tipe71, Tipe72, Tipe73, Tipe74];

export default tipe7;
